function swiperSlider() {
    var swiper = new Swiper('.js-banner-carousel__slide-wrapper.slide', {
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        effect: "slide",
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        noSwipingClass: "swiper-no-swiping",
        passiveListeners: false,
        containerModifierClass: "swiper-container-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideVisibleClass: "swiper-slide-visible",
        wrapperClass: "swiper-wrapper",
        navigation: {
            nextEl: '.js-banner-carousel__btn-next',
            prevEl: '.js-banner-carousel__btn-prev',
        },
        pagination: {
            el: '.banner-carousel__pagination',
            type: 'progressbar'
        },
        autoplay: {
            delay: 5000
        },
        breakpoints: {
            1001: {
                slidesPerView: 1
            }
        }
    });

    const swiper2 = new Swiper('.c-home-products', {
        speed: 400,
        effect: "slide",
        autoplay: false,
        loop: false,
        slidesPerView: 2,
        spaceBetween: 2,
        pagination: {
            el: '.js-carousel-product__pagination',
            type: 'progressbar'
        },
        breakpoints: {
            481: {
                slidesPerView: 3,
            },
            1081: {
                slidesPerView: 4
            }
        }
    });
}

$(document).ready(function () {
    swiperSlider();
});